// Sample types of one investigation: several may be allowed, exactly one is the default (what a registration starts with).
// Pure helpers behind the multi-select on the Investigation Master form.

/** Ticks or unticks a sample type. The first ticked type becomes the default; unticking the default hands it to the first one left. */
export const toggleSampleType = (ids, defaultId, id) => {
  const has = ids.includes(id);
  const next = has ? ids.filter((x) => x !== id) : [...ids, id];
  let nextDefault = defaultId;
  if (next.length === 0) nextDefault = null;
  else if (!has && (defaultId === null || defaultId === undefined)) nextDefault = id;
  else if (has && id === defaultId) nextDefault = next[0];
  return { ids: next, defaultId: nextDefault ?? null };
};

/** Makes a ticked type the default. A type that is not ticked cannot be the default. */
export const makeDefault = (ids, defaultId, id) => (ids.includes(id) ? { ids, defaultId: id } : { ids, defaultId: defaultId ?? null });

/**
 * Reads what the server returns for an investigation (sampleTypes with isDefault, plus the single sampleTypeId of older
 * records) into the form's two fields.
 */
export const selectionFromDetail = (detail) => {
  const list = Array.isArray(detail?.sampleTypes) ? detail.sampleTypes : [];
  const ids = [];
  list.forEach((s) => { if (!ids.includes(s.sampleTypeId)) ids.push(s.sampleTypeId); });
  let defaultId = list.find((s) => s.isDefault)?.sampleTypeId ?? null;
  if (detail?.sampleTypeId && !ids.includes(detail.sampleTypeId)) ids.unshift(detail.sampleTypeId);
  if (defaultId === null) defaultId = detail?.sampleTypeId || ids[0] || null;
  return { ids, defaultId };
};

/** What goes to the server: the default as sampleTypeId, every ticked type (default included, no repeats) as sampleTypeIds. */
export const selectionToPayload = (ids, defaultId) => {
  const unique = [...new Set(ids)];
  const def = unique.includes(defaultId) ? defaultId : unique[0] ?? null;
  return { sampleTypeId: def, sampleTypeIds: unique };
};

/** The text on the closed control. */
export const selectionSummary = (ids, defaultId, nameOf) => {
  if (!ids.length) return '';
  const first = nameOf(defaultId ?? ids[0]) || '';
  return ids.length === 1 ? first : `${first} (default) +${ids.length - 1} more`;
};
